import { Component, Input } from '@angular/core';

import { CompanyService }  from '../companies/company.service';
import { SessionService }  from '../sessions/session.service';

import { CustomerSourceModel }  from './models/customer-source';
import { PaymentMethodModel }   from './models/payment-method';
import { ProductCategoryModel } from './models/product-category';
import { TemplateModel }        from '../templates/typings/template';

@Component({
  selector   : 'wor-company-lists',
  template: require('./company-lists.component.html')
})
export class CompanyListsComponent {
  @Input() customerSources: Array<CustomerSourceModel>;
  @Input() documentTemplates: Array<TemplateModel>;
  @Input() emailTemplates: Array<TemplateModel>;
  @Input() invoiceNoteTemplates: Array<TemplateModel>;
  @Input() jobCardTemplates: Array<TemplateModel>;
  @Input() paymentMethods: Array<PaymentMethodModel>;
  @Input() productCategories: Array<ProductCategoryModel>;
  @Input() productGroups: any;
  @Input() smsTemplates: Array<TemplateModel>;
  @Input() unitForSaleTemplates: Array<TemplateModel>;

  loaded = true;

  constructor(
    public companyService: CompanyService,
    public sessionService: SessionService
  ) {}

  isBoschPuppet (): boolean {


    return this.companyService.isBrandPuppet('bosch');


    };


  }
